module.exports = __webpack_public_path__ + "img/qrec_scheme-20-16.c9f3050c.png";